/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */

// This MUST remain a directive, compnets do not allow placement as Attribute
// use in index.html as <body heartbeat>
(function () {
  'use strict';
  
  /**
   * @ngdoc directive
   * @name heartbeat.directive:heartbeat
   * @restrict A
   * @element
   *
   * @description detects backend outages and warns user
   *
   *
   * @example
   <html name="index.html">
   <body heartbeat></body>
   </html>
   *
   */
  angular
    .module('vcutils.heartbeat')
    .directive('heartbeat', heartbeat);
  
  
  heartbeat.$inject = ['$log', 'vertxEventBusService', 'vertxEventBus','$state', '$rootScope', '$interval', '$window', '$timeout', '$uibModal'];
  
  function heartbeat($log, vertxEventBusService, vertxEventBus, $state, $rootScope, $interval, $window, $timeout, $uibModal) {
    return {
      restrict: 'A',
      scope: {},
      replace: false,
      controllerAs: 'heartbeat',
      controller: function () {
        let vm = this;
        vm.name = 'heartbeat';
        vm.refresh = refresh;

        function refresh () {
          $window.location.reload();
        }

        $interval(function () {
          // $log.debug('timout called');
          if (angular.isUndefined($rootScope.connfailure)) {
            $log.debug('heartbeat - initialising $rootScope.connfailure to 0');
            $rootScope.connfailure = 0;
          }
          
          // $log.debug('heartbeat : ', $rootScope.heartbeat.isBetween(moment().subtract(5, 'second'), moment()));
          
          if (angular.isDefined($rootScope.heartbeat)) {
            if ($rootScope.heartbeat.isBetween(moment().subtract(5000, 'ms'), moment())) {
              // $log.debug('heartbeat - validated');
              $rootScope.connfailure = 0;
            }
            else {
              $rootScope.connfailure++;
              $log.debug('heartbeat - connection failed: ', $rootScope.connfailure, moment().toISOString());
            }
            
            if ($rootScope.connfailure >= 3) {
              $log.error('heartbeat - Error allowed number of misses exceeded: ', $rootScope.connfailure, moment().toISOString(), $rootScope.heartbeat);
              $log.debug('heartbeat vertxbus connection status - ', vertxEventBusService.getConnectionState() );
              $log.debug('heartbeat vertxbus connection isConnected - ', vertxEventBusService.isConnected() );
              $log.debug('heartbeat vertxbus connection isConnectionOpen - ', vertxEventBusService.isConnectionOpen() );
              $log.debug('heartbeat vertxbus message queue length - ', vertxEventBusService.getMessageQueueLength() );

              // $log.debug('heartbeat vertxbus forcing immediate reconnect');


              if (angular.isUndefined($rootScope.lastebrestart)) {
                // $log.debug('heartbeat - validated');
                $rootScope.lastebrestart = moment();
              }

              // only force reconnect if vertxeventbus was not reconnected recently
/*              if (!$rootScope.lastebrestart.isBetween(moment().subtract(15000, 'ms'), moment())) {
                $log.debug('Force reconnect heartbeat vertxbus at: ', moment().toISOString());
                vertxEventBus.reconnect(true);
                $log.debug('heartbeat vertxbus connection status after forced reconnect - ', vertxEventBusService.getConnectionState() );
              }*/


              if (angular.isUndefined($rootScope.connalert)) {
                $log.debug('heartbeat - opening new connection loss popup: ', $rootScope.connalert);
                $rootScope.connalert = $uibModal.open({
                  template: '<div class="modalspacer">' +
                  '<div class="alert alert-danger" ng-hide="connfailure === 0">' +
                  '<h1 style="text-align: center"><i class="fa fa-warning"></i> Die Verbindung zum Server wurde unterbrochen!</h1>' +
                  '<h3 style="text-align: center">Dieser Hinweis verschwindet, sobald der Fehler behoben ist.</h3>' +
                  '<div class="spacer-top"><h3>Fehlerbehebung</h3>' +
                  '<ul><li>Bitte 2 Minuten warten, Verbindungsfehler beheben sich oft von alleine.</li>' +
                  '<li>Bei WLAN/VPN Verbindungen (Handy, Tablet, Laptop) WLAN/VPN abdrehen, wieder neu verbinden und 1 Minute warten.</li>' +
                  '<li>Strg + R drücken (CMD + R für Mac), oder hier <span class="btn btn-danger" ng-click="vm.refresh()"><span class="fa fa-refresh"></span> Seite neu laden</span> </li>' +
                  '</ul></div></div>' +
                  '<div class="alert alert-success" ng-show="connfailure === 0">' +
                  '<h1 style="text-align: center"><i class="fa fa-check"></i> Die Verbindung zum Server wurde wieder hergestellt!</h1>' +
                  '<h3>Je nach dem wo Sie gerade gearbeitet haben, kann es zu Datenverlust der letzten 10 Sekunden gekommen sein.' +
                  'Bitte überprüfen und ggf. nochmal eintragen.</h3>' +
                  '<button class="btn btn-success" ng-click="connalert.close()">Weiterabeiten</button>' +
                  '</div></div>',
                  size: 'lg',
                  backdrop: 'static',
                  controllerAs: 'miCtrl',
                  bindToController: true,
                  controller: function () {
                    // $log.debug('modal $scope: ', $rootScope);
                    // this an empty controller - weird
                    let vmi = this;
                    vmi.$rootScope = $rootScope;
                  },
                  resolve: {}
                });
              } else {
                // $log.debug('heartbeat - $rootscope.connalert already existed: ', $rootScope.connalert);

              }
            }
          }
        }, 3000);
        
      },
      link: function (scope, element, attrs, ctrl) {
        /* jshint unused:false */
        /* eslint "no-unused-lets": [2, {"args": "none"}] */

        const heartbeatHandler = function (msg) {
          let now = moment();
          if ($rootScope.connfailure > 2) {
            let d = now.diff($rootScope.heartbeat);
            $log.debug('heartbeat - autorecovered after: ', moment.utc(d).format('HH:mm:ss'), ' after ', $rootScope.connfailure, ' fails');
          }
          $rootScope.heartbeat = now;
          // $log.debug('heartbeat - received: ', $rootScope.heartbeat);
        };

        vertxEventBusService.on('heartbeat', {}, heartbeatHandler);


//         TODO: figure out how to unlink heartbeat handler on destroy
/*
        vm.$onDestroy = function () {
          vertxEventBusService.unregisterHandler('heartbeat', {}, heartbeatHandler);
        };*/


      }
    };
  }
}());
